import PropTypes from "prop-types";
import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Box, Button, Grid, MenuItem, Typography } from "@material-ui/core";

import SelectItem from "../../../../components/SelectItem/SelectItem";
import SelectWithTitle from "../../../../components/SelectWithTitle/SelectWithTitle";
import { CUSTOMER_SETTINGS_CHAT_QUEUE_FORM } from "../../../../constants/forms";
import {
  CUSTOMER_CHAT_QUEUE_TYPE,
  NO_QUEUE_TYPE,
  QUEUE_TYPE,
  SAVE,
} from "../../../../constants/strings";
import {
  loadChatQueueFormValues,
  onSaveChatQueue,
} from "../../../../features/customerSettings/customerSettings.action";
import {
  CHAT_QUEUE_TYPES,
  QUEUE_TYPE_FIELD,
  QUEUE_TYPES,
} from "../../../../features/customerSettings/customerSettings.constants";
import { getInitialChatQueueFormValues } from "../../../../features/customerSettings/customerSettings.models";
import styles from "./ChatQueueForm.module.scss";

const ChatQueueForm = ({ onSaveChatQueue }) => (
  <Box display="flex" flexDirection="column" width="100%" mb={2}>
    <Box display="flex" flexDirection="row" width="100%" mb={2} mt={4}>
      <Typography className={styles["title-text"]}>
        {CUSTOMER_CHAT_QUEUE_TYPE}:
      </Typography>
    </Box>
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item md={4} xs={12}>
        <Field
          component={SelectWithTitle}
          name={QUEUE_TYPE_FIELD}
          label={QUEUE_TYPE}
          displayEmpty
        >
          <MenuItem value={QUEUE_TYPES.NONE}>
            <SelectItem title={NO_QUEUE_TYPE} />
          </MenuItem>
          {CHAT_QUEUE_TYPES.map((queueType) => (
            <MenuItem key={queueType} value={queueType}>
              <SelectItem title={queueType} />
            </MenuItem>
          ))}
        </Field>
      </Grid>
      <Grid item>
        <Button
          color="primary"
          disableElevation
          className={styles.actionButton}
          onClick={onSaveChatQueue}
        >
          <span className={styles.buttonText}>{SAVE}</span>
        </Button>
      </Grid>
    </Grid>
  </Box>
);

ChatQueueForm.propTypes = {
  onSaveChatQueue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  loadFormValues: () => dispatch(loadChatQueueFormValues()),
  onSaveChatQueue: () => dispatch(onSaveChatQueue()),
});

export default compose(
  reduxForm({
    form: CUSTOMER_SETTINGS_CHAT_QUEUE_FORM,
    initialValues: getInitialChatQueueFormValues(),
  }),
  connect(null, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.loadFormValues();
    },
  })
)(ChatQueueForm);
